export default __webpack_public_path__ + "static/media/fig2.4c29d634.jpg";